import { Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatAutocomplete, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { Observable, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { FabrikatDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/fabrikat-dto';
import { ModelFilter } from '../../aftale/models';

@Component({
    selector: 'app-fabrikat-filter',
    templateUrl: './fabrikat-filter.component.html',
    styleUrls: ['./fabrikat-filter.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FabrikatFilterComponent implements OnInit, OnDestroy, OnChanges {
  unsubscribe$ = new Subject<void>();

  fabrikatCtrl = new UntypedFormControl();

  filteredFabrikater: Observable<FabrikatDto[]>;
  selectedFabrikater: FabrikatDto[] = [];

  @Input() fabrikater: FabrikatDto[];

  @Input() filter: ModelFilter;

  @Output() fabrikatChange: EventEmitter<number[]> = new EventEmitter();

  @ViewChild('fabrikatInput') fabrikatInput: ElementRef<HTMLInputElement>;
  @ViewChild('fabrikatAuto') matAutocomplete: MatAutocomplete;

  constructor() {
    this.filteredFabrikater = this.fabrikatCtrl.valueChanges.pipe(
      takeUntil(this.unsubscribe$),
      map((fabrikat) => (fabrikat ? this._filter(fabrikat) : this.fabrikater.slice().map((y) => y)))
    );
  }

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.unsubscribe();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.fabrikater && this.fabrikater) {
      this.selectedFabrikater = this.filter.fabrikatIds.map((fabrikatId) => this.fabrikater.find((x) => x.id == fabrikatId));
    }
    if (changes.filter && this.fabrikater) {
      this.selectedFabrikater = this.filter.fabrikatIds.map((fabrikatId) => this.fabrikater.find((x) => x.id == fabrikatId));
    }
  }

  onFabrikatChange() {
    this.filter.fabrikatIds = this.selectedFabrikater.map((x) => x.id);
    this.fabrikatChange.emit(this.filter.fabrikatIds);
  }

  removeFabrikat(fabrikat: FabrikatDto): void {
    const index = this.selectedFabrikater.indexOf(fabrikat);

    if (index >= 0) {
      this.selectedFabrikater.splice(index, 1);
    }
    this.onFabrikatChange();
  }

  fabrikatSelected(event: MatAutocompleteSelectedEvent): void {
    var p = this.fabrikater.find((x) => x.id == event.option.value.id);

    if (this.selectedFabrikater.find((x) => x.id == p.id)) {
    } else {
      this.selectedFabrikater.push(p);
    }

    this.fabrikatInput.nativeElement.value = '';
    this.fabrikatCtrl.setValue(null);
    this.onFabrikatChange();
  }

  private _filter(value: string): FabrikatDto[] {
    if (typeof value !== 'string') return;
    return this.fabrikater.filter(
      (option) =>
        option.name.replace(/\s/g, '').toLowerCase().indexOf(value.replace(/\s/g, '').toLowerCase()) >= 0 &&
        !this.selectedFabrikater.find((x) => x.id == option.id)
    );
  }
}
